import config from '@/config';
import request from '@/request/request.gateway.js';

export default {
	// 获取学生信息列表
	getSchoollivingList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/school-video/school-list`,
			params
		});
	},
	// 获取设备状态日志列表
	getDeviceStatusLog(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/moe-play/devicelog/get_list`,
			params
		});
	}
};
